import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { getUserLoading, getUser } from '../../data/selectors/userAuthSelectors';
import LoadingSpinner from '../loadingSpinner/LoadingSpinner';

// Centralizes the auth guard for protected routes. Waits for the async
// session check (`loadUser`, dispatched from Header) to resolve before
// rendering children or redirecting, so a hard refresh no longer flashes
// the login screen for an authenticated user.
//
// NOTE: admin routes (/know-admin, /org-admin, /gemini-admin) are NOT
// wrapped by RequireAuth and may still exhibit the flash if they don't
// independently wait on `userLoading`. Auditing them is a follow-up.
function RequireAuth({ children }) {
  const userLoading = useSelector(getUserLoading);
  const user = useSelector(getUser);
  const location = useLocation();

  if (userLoading) return <LoadingSpinner />;
  if (!user.email) {
    const returnPath = location.pathname.slice(1) + location.search;
    return <Navigate to={`/login#${returnPath}`} replace />;
  }
  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.node,
};

export default RequireAuth;
